import React from "react";

export function ProgressRing({ value = 0, total = 12, size = 128, stroke = 8, center }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = total ? Math.min(1, value / total) : 0;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="progress-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#26231E" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#CBA471"
          strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={circ * (1 - pct)}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {center || (
          <>
            <span className="font-serif text-3xl text-ink leading-none">{value}</span>
            <span className="text-xs text-faint mt-1">{value} / {total}</span>
          </>
        )}
      </div>
    </div>
  );
}
